<div class="wrapper" [ngStyle]="{ display: message ? 'flex' : 'none' }">
  <i class="icon" [ngClass]="icon" [ngStyle]="{ height: height, width: width }"></i>
  <p class="message" [innerHTML]="message"></p>
</div>
